import { Box, useMediaQuery, useTheme } from "@mui/system";
import Grid from "@mui/material/Grid";
import {
  Typography,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import ArrowForwardIosIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  messages,
  applyNow,
  referralLinkMap,
  referralImageMap,
  flexiPaymentInfo,
  withdrawInfo,
} from "../../data/constant";
import { statusPopupSelector } from "../../services/redux/slices/statusPopupSlice";
import {
  authSelector,
  userLoanCatSelector,
} from "../../services/redux/slices/authSlice";
import postsServices from "../../services/api/service/postsService";
import { encrypt, decrypt } from "../../utils/crypto";
import { RootState } from "../../services/redux/store";
import { setDocumentDiscardModal } from "../../services/redux/slices/documentFormSlice";
import { ROUTES } from "../../routes/routerConfig";
import { Link as RouterLink } from "react-router-dom";
import { disbReInfo, paymentInfo } from "../../data/constant";
// import InfoLabelWithLink from "./InfoLabelWithLink";
import { commonCss } from "../ui/commonCss";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AwsReferral from "../../assets/images/aws_referral.png";
import AwsOfferModal from "../../pages/dashboard/AwsOfferModal";
interface PayloadNew {
  cifNumber: any;
  businessType: any;
  loanCategory: any;
}
const RightLayoutOutlet = () => {
  const navigate = useNavigate();
  const { refreshValue } = useSelector(statusPopupSelector);
  const { userProfile, businessType } = useSelector(authSelector);
  const { userLoanCategory } = useSelector(userLoanCatSelector);
  const [fetchNotificatinData, setFetchNotificatinData] = useState([]);
  const [isAwsOfferModalOpen, setIsAwsOfferModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = () => {
    navigate("/notifications");
  };
  const dispatch = useDispatch();
  const selectedFormType = useSelector(
    (state: RootState) => state.documentFormSlice
  );
  const selectedIndex = useSelector(
    (state: RootState) => state.tabs.selectedIndex
  );
  const productName = useSelector((state: RootState) => state.tabs.productName);

  const termLoanData = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );

  const isShowReferralBanner = useSelector(
    (state: RootState) => state?.dashboardData?.isShowReferralBanner
  );

  const sanctionedDisbursedData = useSelector(
        (state: RootState) => state?.dashboardData?.sanctionedDisbursedData
  );

  const handleViewAll = () => {
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
    } else {
      navigate("/notifications");
    }
  };
  const handleNavigateLink = (link: any) => {
    return (
      <>
        <RouterLink
          to={link.path}
          target="_blank"
          rel="noopener noreferrer"
          style={commonCss.routerLinkText}
        >
          {link.label}
        </RouterLink>
      </>
    );
  };
  const tabType = useSelector((state: RootState) => state.tabs.tabType);

  useEffect(() => {
    const fetchNotification = () => {
      setIsLoading(true);
      if (
        (tabType == "Term Loan" && termLoanData?.TermLoan?.length > 0) ||
        (tabType == "Flexi Term Loan" &&
          termLoanData?.Flexi?.length > 0 &&
          businessType?.id != undefined)
      ) {
        const payload: PayloadNew = {
          cifNumber:
            tabType == "Flexi Term Loan"
              ? userProfile?.cifEntity
              : userProfile?.cifNumber,
          businessType: encrypt(businessType?.id),
          loanCategory:
            tabType == "Term Loan"
              ? encrypt(termLoanData?.TermLoan[0]?.loanCategoryId)
              : encrypt(termLoanData?.Flexi[0]?.loanCategoryId),
        };
        postsServices
          .addPost("api/v1/notifications/get-latest-notifications", payload)
          .then((response) => {
            let data = response?.data?.data ?? "";
            if (data) {
              let decrptedData = decrypt(data);
              let jsonData = JSON.parse(decrptedData);
              setFetchNotificatinData(jsonData);
            }
          })
          .catch((error: any) => {
            // const errorMessage =
            //   error.response?.data?.message ||
            //   messages.withdrErrorMessages.commonError;
          });
      }
    };

    fetchNotification();
  }, [refreshValue, userProfile, termLoanData, tabType]);


  const text = "We need some more details to process your disbursement";
  const referralImage = referralImageMap[selectedIndex]?.web;
  const referralLink = referralLinkMap?.[selectedIndex];

   const isShowAwsBannerWithoutCarousel = () => {
    if(sanctionedDisbursedData[0]?.status === "A" &&
    (sanctionedDisbursedData[0]?.loanTypeName === "ELFORN" || sanctionedDisbursedData[0]?.loanTypeName === "ELDOMC")) {
      return true
    }
    return false
  }

  return (
    <Box
      sx={{
        borderLeft: "1px solid #cecece",
        paddingLeft: "27px",
        height: "100%",
      }}
    >
      {(selectedIndex === 0 || selectedIndex === 3 || selectedIndex === 4) &&
      productName != "TermLoanDisbursement" ? (
        <>
          <Grid container className="document-container">
            <Grid item sm={11}>
              <Typography variant="h6" className="loan-account-sub-headings">
                Updates
              </Typography>
            </Grid>
          </Grid>
          <Card>
            <CardContent>
              <Grid container spacing={2} justifyContent="center">
                {fetchNotificatinData?.map((item: any, index: any) => (
                  index < 2 ? (
                      <Grid item xs={12} key={index}>
                    <Typography
                      variant="body2"
                      sx={{
                        cursor: "pointer",
                        color: "rgba(75, 70, 92, 1)",
                        fontSize: "clamp(8px, 1vw, 12px)",
                      }}
                      onClick={() => handleClick()}
                    >
                      {item?.message?.length > 50
                        ? `${item?.message.substring(0, 50)}...`
                        : item?.message}
                    </Typography>
                  </Grid>
                  ) : null
                ))}
              </Grid>
            </CardContent>
            <Divider className="" style={{ width: "100%" }} />
            <Box sx={{ padding: "6px 16px 6px 16px" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  lineHeight: "21px",
                  fontSize: "13px",
                  color: "#168794",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClick={handleViewAll}
              >
                View all
              </Typography>
            </Box>
          </Card>
        </>
      ) : selectedIndex === 2 ? (
        <>
          <Grid container className="document-container">
            <Grid item sm={11}>
              <Typography className="loan-account-sub-headings">
                Information related to Payment
              </Typography>
            </Grid>
          </Grid>
          <Card>
            <CardContent>
              <Grid container spacing={2} justifyContent="center">
                <ul>
                  {tabType == "Term Loan" &&
                    termLoanData?.TermLoan?.length > 0 && (
                      <>
                        {paymentInfo?.map((item: any, index: any) => (
                            <Grid item xs={12} key={index}>
                              <Typography
                                variant="body2"
                                sx={{
                                  cursor: "pointer",
                                  color: "rgba(75, 70, 92, 1)",
                                  fontSize: "clamp(8px, 1vw, 12px)",
                                }}
                              >
                                <li> {item?.label}</li>
                                {/* <li> <InfoLabelWithLink label={item?.label} link={item?.link} /></li> */}
                              </Typography>
                            </Grid>
                        ))}
                      </>
                    )}
                  {tabType == "Flexi Term Loan" &&
                    termLoanData?.Flexi?.length > 0 && (
                      <>
                        {flexiPaymentInfo?.map((item: any, index: any) => (
                           index < 2 ? (  <Grid item xs={12} key={index}>
                            <Typography
                              variant="body2"
                              sx={{
                                cursor: "pointer",
                                color: "rgba(75, 70, 92, 1)",
                                fontSize: "clamp(8px, 1vw, 12px)",
                              }}
                            >
                              <li> {item?.label}</li>
                            </Typography>
                          </Grid>) : null
                        ))}
                      </>
                    )}
                </ul>
              </Grid>
            </CardContent>
          </Card>
        </>
      ) : (
        (productName === "TermLoanDisbursement" || selectedIndex === 1) && (
          <>
            <Grid container className="document-container">
              <Grid item sm={11}>
                <Typography className="loan-account-sub-headings">
                  Information related to {termLoanData?.Flexi?.length > 0 ? "Withdrawal" : " Fund Release Request"}
                </Typography>
              </Grid>
            </Grid>
            <Card>
              <CardContent>
                <Grid container spacing={2} justifyContent="center">
                  <ul>
                    {termLoanData?.Flexi?.length > 0
                      ? withdrawInfo?.map((item: any, index: any) => (
                        <Grid item xs={12} key={index}>
                            <Typography
                              variant="body2"
                              sx={{
                                cursor: "pointer",
                                color: "rgba(75, 70, 92, 1)",
                                fontSize: "clamp(8px, 1vw, 12px)",
                              }}
                            >
                              <li> {item?.label}</li>
                            </Typography>
                          </Grid>
                        ))
                      : termLoanData?.TermLoan?.length > 0
                      ? disbReInfo?.map((item: any, index: any) => (
                        <Grid item xs={12} key={index}>
                            <Typography
                              variant="body2"
                              sx={{
                                cursor: "pointer",
                                color: "rgba(75, 70, 92, 1)",
                                fontSize: "clamp(8px, 1vw, 12px)",
                              }}
                            >
                              <li> {item?.label}</li>
                            </Typography>
                          </Grid>
                        ))
                      : null}
                  </ul>
                </Grid>
              </CardContent>
            </Card>
          </>
        )
      )}
      <Box>
        {selectedIndex === 0 && <Card sx={{ height: "auto", marginTop: "25px" }}>
          <CardActionArea
            onClick={() =>
              referralLink && window.open(referralLink, "_blank")
            }
          >
            <CardMedia
              component="img"
              image={referralImage}
              alt="Referral banner"
            />
          </CardActionArea>
        </Card>}
        {selectedIndex !== 0 && (
          <Carousel
            responsive={{
              desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
              },
              tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 1,
              },
              mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
              },
            }}
            itemClass="carousel-item-padding-aws"
            swipeable={true}
            draggable={true}
            showDots={false}
            key={"aws-referral-carousel-right-layout"}
            infinite={true}
            arrows={false}
            ssr={true}
            autoPlay={isShowAwsBannerWithoutCarousel() ? true : false}
            autoPlaySpeed={3000}
            keyBoardControl={true}
            customTransition="transform 300ms ease-in-out"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            deviceType={isXsOrSm ? "mobile" : "desktop"}
            dotListClass="custom-dot-list-style"
            partialVisible={true}
            centerMode={false}
            minimumTouchDrag={50}
          >
            {isShowReferralBanner && sanctionedDisbursedData[0]?.status === "A" && referralImage &&
            <Card sx={{ height: "auto", marginTop: "25px", width:"100%" }}>
              <CardActionArea
                onClick={() =>
                  referralLink && window.open(referralLink, "_blank")
                }
              >
                <CardMedia
                  component="img"
                  image={referralImage}
                  alt="Referral banner"
                />
              </CardActionArea>
            </Card>}
            {isShowAwsBannerWithoutCarousel() && 
            <Card sx={{ height: "auto", marginTop: "25px", width:"100%" }}>
              <CardActionArea
                onClick={() =>
                  setIsAwsOfferModalOpen(true)
                }
              >
                <CardMedia
                  component="img"
                  image={AwsReferral}
                  alt="AWS Referral banner"
                />
              </CardActionArea>
            </Card>}
            
          </Carousel>
        )}
        <Card sx={{ height: "auto", marginTop: "25px" }}>
          <CardActionArea>
            <CardMedia
              component="img"
              image={require("../../assets/images/rightBanner.jpg")}
              alt="green iguana"
              // onClick={() => window.open(applyNow, "_blank")}
            />
          </CardActionArea>
        </Card>
      </Box>
      {isAwsOfferModalOpen && <AwsOfferModal isAwsOfferModalOpen={isAwsOfferModalOpen} setIsAwsOfferModalOpen={setIsAwsOfferModalOpen} />}
    </Box>
  );
};

export default RightLayoutOutlet;
